module.exports = require("@swa-ui/authentication/src/components/MfaEnterPasscodeForm/MfaEnterPasscodeForm.module.scss");